import React from 'react';

const NoEvent = () => {
    return (
        <div className="container m-5">
            <div className="alert alert-warning text-center p-5">
                <h2>You do not register any event yet.</h2>
            </div>
        </div>
    );
};

export default NoEvent;